import { z } from 'zod/v4'
import {
  type ApiHydraResponse,
} from '@services/api/declarations'
import { ClubResourceSchema } from '@libs/fsc/types/club'
import { type ClubGroupLegacy } from '@libs/fsc/types/legacy'
import { RoleKind } from '@libs/fsc/types/user'

// ***
// SCHEMAS
// ***

const IdNameSchema = z.object({
  id: z.number(),
  name: z.string(),
})

export const LegacyClubTeamSchema = z.object({
  id: z.number(),
  name: z.string(),
  category: IdNameSchema,
  gender: IdNameSchema,
  sport: IdNameSchema,
  letter: z.string(),
  playersFile: z.null(),
  order: z.number(),
  customName: z.string(),
})

export const LegacyClubCategorySchema = z.object({
  id: z.number(),
  name: z.string(),
})

export const ClubResourceWithRolesSchema = ClubResourceSchema.extend({
  roles: z.array(z.enum(RoleKind)),
  profiles: z.record(z.string(), z.object({
    hash: z.string(),
    type: z.number(),
    preEnrollment: z.boolean(),
    accessController: z.boolean(),
  })),
})

// ***
// EXPORTED TYPES
// ***

export type IdName = z.infer<typeof IdNameSchema>
export type LegacyClubTeam = z.infer<typeof LegacyClubTeamSchema>
export type LegacyClubCategory = z.infer<typeof LegacyClubCategorySchema>
export type ClubResourceWithRoles = z.infer<typeof ClubResourceWithRolesSchema>

export interface LegacyStoreShape {
  getLegacyPeopleGroupByClub: ApiHydraResponse<ClubGroupLegacy[]>
}
